/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Drift_Identical_PrevInputs */

const en_landing_drift_identical_prev = /** @type {(inputs: Landing_Drift_Identical_PrevInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`identical to the previous pass`)
};

const zh_landing_drift_identical_prev = /** @type {(inputs: Landing_Drift_Identical_PrevInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`与上一轮完全一致`)
};

/**
* | output |
* | --- |
* | "identical to the previous pass" |
*
* @param {Landing_Drift_Identical_PrevInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_drift_identical_prev = /** @type {((inputs?: Landing_Drift_Identical_PrevInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Drift_Identical_PrevInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_drift_identical_prev(inputs)
	return zh_landing_drift_identical_prev(inputs)
});
export { landing_drift_identical_prev as "landing.drift.identical_prev" }